// extracted by mini-css-extract-plugin
export default {"component":"PageHeader__component-uzsV","title":"PageHeader__title-mUzg","noStrap":"PageHeader__noStrap-KpzX","content":"PageHeader__content-K8ih"};